<div class="audio-card" *ngIf="chat">
  <div class="icon" *ngIf='chat.get("Owner") === appConfig.Shared.Assistant.Owner.DOCTOR'>
  <img *ngIf="doctor" [src]='doctor.doctorDisplayImage || doctor.DoctorImageThumbnail || "https://cdn.cureskin.com/app/img/dp-dr-charu.jpg"' />
  </div>
  <div [ngClass]="{ 'content' : chat.get('Mode') !== appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE, 'tw-flex-grow-1 tw-pr-[15px] tw-pt-0 tw-pb-0 tw-flex tw-flex-col tw-text-gray-800': chat.get('Mode') === appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE }">
  <div class="fontS1" *ngIf="chat.get('Mode') !== appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE">
    {{isDoctorCallExperiment ? '"Please listen to your audio message"' :
  chat.get('Message')}}
  </div> 
  <div class="fontS1" *ngIf="chat.get('Mode') === appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE">
    Please listen to your audio message
  </div>  
  <audio class="mT10" controls="controls" controlslist="nodownload" *ngIf="chat.get('Mode') === appConfig.Shared.Assistant.Mode.AUDIO && chat.get('audioUrl')" (error)="audioError($event)" type="audio/mpeg" (play)="onAudioPlay($event, chat)" (ended)="onAudioPlayEnd($event, chat)">
    <source [src]="chat.get('audioUrl')" />
  </audio>
  <audio class="tw-w-full tw-h-[45px] tw-mt-[10px]" controls="controls" controlslist="nodownload" *ngIf="chat.get('Mode') !== appConfig.Shared.Assistant.Mode.AUDIO" (error)="audioError($event)" type="audio/mpeg/mp3" (play)="onAudioPlay($event, chat)" (ended)="onAudioPlayEnd($event, chat)">
    <source [src]="chat.get('Message')" />
  </audio>
  <div class="fontS1 mT10" *ngIf="isInternalUser">
    <div class="bold">Internal Note:</div>
    <div class="mT5">{{chat.get('internalNote')}}</div>
  </div>
  <div class="timestamp" *ngIf="chat.get('Mode') !== appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE">
    <em class="cs-icon-tick clr-green fontS2" *ngIf="chat.get('trackingDetails')?.audioPlayed && isInternalUser"></em><em class="cs-icon-tick clr-green fontS2" *ngIf="chat.get('trackingDetails')?.audioFinished && isInternalUser"></em><span>{{chat.get('createdAt') | date: (isInternalUser ? 'hh:mm a dd MM yy' :
  'hh:mm a') }} &nbsp; {{isInternalUser ? chat.get('OperatorName') ||
  chat.get('Owner') : ''}}</span>
  </div>
  </div>
</div>